import axios from 'axios'
import { REACT_APP_PERITADOR_API } from 'cfgCommon/config'

const endpoint = `${REACT_APP_PERITADOR_API}/takingCarManagment`

export async function getPaginatedListTakingCarManagement({
  search,
  cancelToken
}) {
  if (
    search.includes('car_lot_id[]=') ||
    search.includes('isManagement=false')
  ) {
    const arrayPromise = [
      axios.get(`${endpoint}/getAll${search}`, {
        cancelToken,
        timeout: 300000
      }),
      axios.get(`${endpoint}/getTabs${search}`, {
        cancelToken,
        timeout: 300000
      })
    ]

    const results = await Promise.all(arrayPromise)

    return {
      ...results[0].data.request,
      tabs: results[1].data.request.tabs,
      totalResults: results[1].data.request.tabs.reduce(
        (total, { quantity }) => total + quantity,
        0
      )
    }
  } else {
    const tabsDefault = search.includes('isManagement=false')
      ? [
          { label: 'Pendientes', quantity: 0 },
          { label: 'En Gestión', quantity: 0 },
          { label: 'Aceptados', quantity: 0 },
          { label: 'Finalizados', quantity: 0 }
        ]
      : [
          { label: 'Por ingresar', quantity: 0 },
          { label: 'Ingresados', quantity: 0 },
          { label: 'Minoristas ', quantity: 0 },
          { label: 'Rechazados', quantity: 0 },
          { label: 'Carmuv', quantity: 0 },
          { label: 'No admitidos', quantity: 0 },
          { label: 'Finalizados', quantity: 0 }
        ]
    return {
      tabs: tabsDefault
    }
  }
}
